<template>
  <div>
    <DataTable v-model:selection="modelValue.selectedList" :value="modelValue.dgRowData" v-bind="datagridVBinding">
      <Column v-if="PageType !== 'view'" selectionMode="multiple"></Column>
      <Column v-else field="" header="已歸還" style="min-width: 80px;">
        <template #body="slotProps">
          <div class="d-flex justify-content-center">
            <input type="checkbox" class="p-checkbox p-component" v-model="slotProps.data.IsReturn" disabled>
          </div>
        </template>
      </Column>
      <Column style="min-width: 60px;">
        <template #body="slotProps">
           <router-link :to="getViewLink(slotProps.data)"><button class="view_btn">檢視</button></router-link>
        </template>
      </Column>
      <Column v-for="item in datagridField" :field="item.field" :header="item.header" sortable
        :style="{ 'min-width': item.width }"></Column>
    </DataTable>
  </div>
</template>

<script setup>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { onMounted, reactive, ref } from 'vue';
import { useReturnAssetStore } from '@/store/return_asset/_index';
import { storeToRefs } from 'pinia';
const returnAssetStore = useReturnAssetStore();
const {
  PageType,
} = storeToRefs(returnAssetStore);
const modelValue = defineModel();
const datagridVBinding = reactive({
  size: 'small',
  resizableColumns: true,
  columnResizeMode: 'expand',
  showGridlines: true,
  scrollable: true,
  scrollHeight: '420px',
  // paginator: true,
  // paginatorTemplate: "RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink",
  // currentPageReportTemplate: " 第{currentPage}頁 ，共{totalPages}頁 總筆數 {totalRecords}",
  rows: 10,
  rowsPerPageOptions: [10, 20, 30]
})
const datagridField = [
  { header: "資產編號", field: "AssetsId", width: '120px' },
  { header: "物品名稱", field: "AssetName", width: '120px' },
  { header: "資產狀態", field: "Status", width: '100px' },
  { header: "儲位區域", field: "AreaName", width: '100px' },
  { header: "儲位櫃位", field: "LayerName", width: '100px' },
  { header: "廠商", field: "VendorName", width: '100px' },
  { header: "型號", field: "ProductType", width: '100px' },
  { header: "規格", field: "ProductSpec", width: '100px' },
  { header: "數量", field: "Number", width: '80px' },
  { header: "單位", field: "Unit", width: '50px' },
]
const getViewLink = (data) => {
  let routerName, FormID;
  const Status = data.Status;
  switch (Status) {
    case '設備整合箱':
      routerName = 'Equipment_View';
      FormID = data.FormID;
      break;
    case '維修':
      routerName = 'Repair_View';
      FormID = data.FormID;
      break;
    default:
      routerName = 'Assets_View';
      FormID = data.AssetsId;
      break;
  }
  return {
    name: routerName,
    query: {
      search_id: FormID
    }
  }
}
onMounted(() => {
  // console.log(modelValue.value);
})
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.view_btn {
  @include datagrid_view_button;
  height: 25px;

  &:hover {
    background: #1D7072;
    color: white
  }
}
</style>